import { render } from "./deploy.vue?vue&type=template&id=951c124c"
import script from "./deploy.vue?vue&type=script&lang=ts"
export * from "./deploy.vue?vue&type=script&lang=ts"
script.render = render

export default script